import { createSlice } from "@reduxjs/toolkit";
import { initialStateProps } from "../interfaces/massiveCharge";

const initialState: initialStateProps = {
    fetching: "unknown",
    usedTemplateData: null,
    newTemplateData: null,
    uploadResult: null,
    uploadResultUrl: null,
    validationResult: null,
    uploadStorageResult: null,
    confirmStorage: null,
    uploadProgress: 0, // Initialize progress to 0
    error: ""
}

const massiveChargeSlice = createSlice({
    name: 'massiveCharge',
    initialState,
    reducers: {
        downloadUsedTemplateRequest: (state) => {
            state.fetching = "loading";
            state.error = "";
        },
        downloadUsedTemplateSuccess: (state, action) => {
            state.fetching = "success";
            state.usedTemplateData = action.payload;
        },
        downloadUsedTemplateFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        downloadNewTemplateRequest: (state) => {
            state.fetching = "loading";
            state.error = "";
        },
        downloadNewTemplateSuccess: (state, action) => {
            state.fetching = "success";
            state.newTemplateData = action.payload;
        },
        downloadNewTemplateFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        bulkUploadRequest: (state) => {
            state.fetching = "loading";
            state.error = "";
            // Iniciar con progreso visual
            state.uploadProgress = 5;
        },
        bulkUploadSuccess: (state, action) => {
            state.fetching = "success";
            state.uploadResult = action.payload;
        },
        bulkUploadFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        bulkUploadStorageRequest: (state) => {
            state.fetching = "loading";
            state.error = "";
        },
        bulkUploadStorageSuccess: (state, action) => {
            state.fetching = "success";
            state.uploadStorageResult = {
                ...action.payload,
                fetching: "success"
            };
        },
        bulkUploadStorageFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
            state.uploadStorageResult = {
                fetching: "failure"
            };
        },
        bulkStorageConfirmRequest: (state) => {
            state.fetching = "loading";
            state.error = "";
        },
        bulkStorageConfirmSuccess: (state, action) => {
            state.fetching = "success";
            state.confirmStorage = action.payload;
        },
        bulkStorageConfirmFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        validateUploadRequest: (state) => {
            state.fetching = "loading";
            state.error = "";
            // Mantener el progreso durante la validación
            if (state.uploadProgress === 0) {
                state.uploadProgress = 10; // Iniciar con 10% para mostrar progreso visual
            }
        },
        validateUploadSuccess: (state, action) => {
            state.fetching = "success";
            state.validationResult = action.payload;
        },
        validateUploadFailure: (state, action) => {
            state.fetching = "failure";
            state.error = action.payload;
        },
        updateUploadProgress: (state, action) => {
            // This action updates the upload progress percentage (0-100)
            state.uploadProgress = action.payload;
        },
        cleanMassiveCharge: (state) => {
            state.fetching = initialState.fetching;
            state.usedTemplateData = initialState.usedTemplateData;
            state.newTemplateData = initialState.newTemplateData;
            state.uploadResult = initialState.uploadResult;
            state.validationResult = initialState.validationResult;
            state.uploadStorageResult = initialState.uploadStorageResult;
            state.uploadProgress = initialState.uploadProgress;
            state.error = initialState.error;
        }
    }
});

export const {
    downloadUsedTemplateRequest,
    downloadUsedTemplateSuccess,
    downloadUsedTemplateFailure,
    downloadNewTemplateRequest,
    downloadNewTemplateSuccess,
    downloadNewTemplateFailure,
    bulkUploadRequest,
    bulkUploadSuccess,
    bulkUploadFailure,
    bulkUploadStorageRequest,
    bulkUploadStorageSuccess,
    bulkUploadStorageFailure,
    validateUploadRequest,
    validateUploadSuccess,
    validateUploadFailure,
    bulkStorageConfirmRequest,
    bulkStorageConfirmSuccess,
    bulkStorageConfirmFailure,
    updateUploadProgress,
    cleanMassiveCharge
} = massiveChargeSlice.actions;

export default massiveChargeSlice.reducer;